const namespace = 'Pooling';

export const FETCH_SEATINGS_SUCCESS = `${namespace}/FETCH_SEATINGS_SUCCESS`;
export const FETCH_SEATINGS_ERROR = `${namespace}/FETCH_SEATINGS_ERROR`;
export const FETCH_SEATINGS = `${namespace}/FETCH_SEATINGS`;



// WEBPACK FOOTER //
// ./src/containers/Pooling/constants.js